import React from 'react'
import { TreeEditingContext } from './context'
import { useDeleteNode } from '../tree/TreeActions'
import { idsForNode } from '../tree/nodeUpdates/utility'
import { Box, Button } from '@mui/material'
import { openNode } from '../utility/TreeNavigation'
import { ConfirmCommitButton } from 'shared/ui'
import { NodeType } from 'shared/types/ingestion'
import { LessonPlanView } from './LessonPlanView'
import { useToggleState } from 'shared/hooks'
import { NodeTypeSelect } from 'components/tree/utility/NodeTypeSelect'
import { retrieveIds, updateTreeNode } from '../tree/TreeRequests'
import { NodeCreationToggle } from './NodeCreation'

export function NodeView({
  nodeId,
  treeId,
}: {
  nodeId: string
  treeId: string
}) {
  const deleteNode = useDeleteNode()
  const [editing, toggleEditing] = useToggleState(false)
  const { idMaps, treesUpdated } = React.useContext(TreeEditingContext)
  const node = idMaps[treeId]?.[nodeId]?.node
  if (!node) return null

  async function doDelete() {
    await deleteNode(idsForNode(node))
    treesUpdated([treeId])
  }

  async function updateType(type: string) {
    if (type === node.type) return
    await updateTreeNode({
      ...retrieveIds(node),
      type,
    })
    treesUpdated([treeId])
  }

  return (
    <Box>
      <Box>
        {node.title}
        <Button onClick={() => openNode(node, idMaps[treeId])}>
          Open Kiddom
        </Button>
      </Box>
      <Box>
        <ConfirmCommitButton
          disabled={node.type === NodeType.Course}
          onClick={doDelete}
        >
          Delete
        </ConfirmCommitButton>
      </Box>
      <Box>
        {`Node Type: ${node.type}`}
        {editing && <NodeTypeSelect type={node.type} onSelect={updateType} />}
        <Button onClick={() => toggleEditing()}>Edit</Button>
      </Box>
      <Box padding="5px" border={'1px solid'}>
        <NodeCreationToggle
          node={node}
          onCreate={() => treesUpdated([treeId])}
        />
      </Box>
      <NodeTypeView type={node.type} nodeId={nodeId} treeId={treeId} />
    </Box>
  )
}

function NodeTypeView({
  type,
  nodeId,
  treeId,
}: {
  type: string
  nodeId: string
  treeId: string
}) {
  if (type === NodeType.LessonPlan) {
    return <LessonPlanView nodeId={nodeId} treeId={treeId} />
  }
  return null
}
